module.exports = __webpack_public_path__ + "static/img/active_04.e55ebb7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/survey2/images/activity/active_04.jpg
// module id = XvgF
// module chunks = 0